import React from "react"

function PresentationVideo() {
  return (
    <div className="py-6 bg-gray-50 lg:py-10" id="presentation-video">
        <div className="mb-8">
          <div className="px-4 mx-auto text-center max-w-7xl sm:px-6 lg:px-8">
            <div className="max-w-3xl mx-auto space-y-2 lg:max-w-none">

                <h2 className="text-2xl font-semibold leading-6 tracking-wider text-indigo-600 uppercase">
                  PROP TRADING BASICS
                </h2>

                {/* <p className="text-3xl font-extrabold sm:text-4xl lg:text-5xl">
                  Pros and Cons of Trading Prop
                </p> */}

                {/* <p className="text-xl text-black">
                  Nick shares his insights on the advantages of using funded trading programs to trade and make money.
                </p> */}

            </div>
          </div>
        </div>

      <div className="mx-auto max-w-7xl px-4 sm:px-6 mx-auto max-w-7xl px-4 mt-2 sm:mt-2 sm:px-6 lg:mt-2">
        <div className="lg:grid lg:grid-cols-12 lg:gap-8">
          <div className="face-black pb-10 mt-6 relative sm:max-w-lg sm:mx-auto lg:mt-0 lg:max-w-none lg:mx-0 lg:col-span-6 lg:flex lg:items-center">
            <div className="relative mx-auto w-full shadow-lg lg:max-w-xl">
              <div className="text-center font-bold text-xl sm:text-xl mx-auto w-full text-black mb-4">
                Passing a Prop Firm Challenge, Blake’s Experience
              </div>

              <span className="sr-only">Watch our video to learn more</span>
              <div className="relative text-center aspect-w-16 aspect-h-9">
                <iframe
                  loading="lazy"
                  title="video"
                  className="absolute top-0 left-0 w-full h-full"
                  // src="https://www.youtube.com/embed/qIyfGuJiBs4"
                  src="https://www.youtube.com/embed/joKtqSHR1IE"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>

            </div>
          </div>

          <div className="face-black pb-10 mt-6 relative sm:max-w-lg sm:mx-auto lg:mt-0 lg:max-w-none lg:mx-0 lg:col-span-6 lg:flex lg:items-center">
            <div className="relative mx-auto w-full shadow-lg lg:max-w-xl">
              <div className="text-center font-bold text-xl sm:text-xl mx-auto w-full text-black mb-4">
                Inside Prop Trading, with Josh Powell
              </div>

              <span className="sr-only">Watch our video to learn more</span>
              <div className="relative text-center aspect-w-16 aspect-h-9">
                <iframe
                  loading="lazy"
                  title="video"
                  className="absolute top-0 left-0 w-full h-full"
                  // src="https://www.youtube.com/embed/qIyfGuJiBs4"
                  src="https://www.youtube.com/embed/uURzocjjcdw"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>

            </div>
          </div>
        </div>
      </div>



    </div>
  )
}

export default PresentationVideo
